<template>
  <div class="premium-status">
    <div style="overflow:auto">
      <table border-collapse="collapse">
        <caption style="padding:10px 20px;font-size:2.2rem;color:#fff;background-color:#fb471e;">
          Сравнeние тарифных планов
        </caption>
        <tr>
          <td></td>
          <td style="font-size:2rem;color:#000;background-color:#ddd;">
            Без Premium
          </td>
          <td style="position:relative;font-size:2rem;color:#fff;background-color:#264F36;">
            <strong>Premium</strong>
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold;color:green;">
            повышенная скорость работы сайта
          </td>
          <td class="minus">&#10006;</td>
          <td class="plus">&#10004;</td>
        </tr>
        <tr>
          <td style="font-weight:bold;">
            отключение рекламы в видеоплеере
          </td>
          <td class="minus">&#10006;</td>
          <td class="plus">&#10004;</td>
        </tr>
        <tr>
          <td style="font-weight:bold;">
            отключение баннерной рекламы на сайте
          </td>
          <td class="minus">&#10006;</td>
          <td class="plus">&#10004;</td>
        </tr>
        <tr>
          <td style="font-weight:bold;">
            отключение видеорекламы (flyroll) на сайте
          </td>
          <td class="minus">&#10006;</td>
          <td class="plus">&#10004;</td>
        </tr>
      </table>
    </div>

    <ul>
      <li :style="`background-image: url(/static_files/premium/bg1.jpg?1)`">
        <div class="header-premium" style="position:relative;">
          Premium
          <span>подписка</span>
        </div>

        <div class="body-premium">
          <span>30 Дней</span>
          <div class="sitecoin">
            <i />
            <span>50 Монет</span>
          </div>
        </div>

        <div class="footer-premium">
          <button @click="premiumActivate(30)" class="btn">
            Подключить
          </button>
        </div>
      </li>
    </ul>

    <div v-if="showModal" class="modal">
      <h3>
        У вас уже есть Premium
      </h3>
      <i class="premium-icon" />
      <div>
        <p>
          Срок до {{ user.premium_date | filterDate }}
        </p>
        <div style="text-align: center;margin-top: 10px;">
          <button @click="buyPremium('self', false)" class="dbtn green">
            Обновить подписку
          </button>
        </div>
        <div style="text-align: center;margin-top: 10px;font-size: 1.4rem;cursor: pointer;">
          <span @click="showModal = null">Отмена</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['user']),
  filters: {
    filterDate(val) {
      const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
      const year = new Date(val).getFullYear()
      const month = new Date(val).getMonth()
      const day = new Date(val).getDate()
      const hour = new Date(val).getHours() < 10 ? `0${new Date(val).getHours()}` : new Date(val).getHours()
      const min = new Date(val).getMinutes() < 10 ? `0${new Date(val).getMinutes()}` : new Date(val).getMinutes()
      return `${day} ${months[month]} ${year} ${hour}:${min}`
    }
  },
  watch: {
    premiumPeriod(val) {
      if (!val) {
        this.userFriends = []
      }
    }
  },
  data() {
    return {
      premiumPeriod: null,
      showModal: false,
      userFriends: [],
      gets: {}
    }
  },
  methods: {
    async getFriends() {
      const { data } = await this.$axios.get(`/api/user/friends`)
      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        this.userFriends = data
      }
    },
    premiumActivate(period) {
      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        this.$store.commit('setShowAuthForm', true)
        return
      }
      this.premiumPeriod = period

      this.buyPremium('self')
    },
    async buyPremium(user, check = true) {
      if (this.gets.buyPremium) return
      this.gets.buyPremium = true

      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        this.$store.commit('setShowAuthForm', true)
        return
      }

      if (user === 'self' && check) {
        delete this.gets.buyPremium
        if (this.user.group === 777 && this.user.patron) {
          this.$store.commit('setError', { status: 'info', msg: 'Вы Patron нашего проекта' })
          setTimeout(() => this.$store.commit('clearError'), 2000)
          return
        } else if (this.user.group === 777 && this.premiumPeriod === 50) {
          this.showModal = true
          return
        }
      }

      const body = {
        period: this.premiumPeriod,
        user: user
      }

      const { data } = await this.$axios.post(`/api/user/premium`, body)
      this.showModal = false
      delete this.gets.buyPremium

      if (data.error) {
        this.$store.commit('setError', { status: 'warn', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        // let price = null

        // if (+this.premiumPeriod === 1) {
        //   price = 1
        // } else if (+this.premiumPeriod === 30) {
        //   price = 30
        // } else if (+this.premiumPeriod === 50) {
        //   price = 50
        // }

        // this.userData.balance -= price

        // const user = this.user
        // user.group = data.group
        // this.$store.commit('setUser', user)
        this.$store.commit('setError', { status: 'ok', msg: 'Статус изменен' })
        setTimeout(() => {
          this.$store.commit('clearError')
          location.reload()
        }, 2000)
      }
    }
  },
}
</script>

<style lang="stylus">
.premium-status
  padding: 0 0 20px;
  .friends-list
    margin-top: 10px
    max-height: 100px
    overflow-y: auto
    .item
      display: grid
      grid-template-columns: 32px auto
      grid-gap: 10px
      align-items: center
      cursor: pointer
      .poster
        width: 32px
        height: 32px
        border-radius: 50%
        overflow: hidden
        img
          width: 100%
          min-height: 100%
          object-fit: cover
      strong
        font-size: 1.4rem
  .modal
    display grid
    align-items center
    justify-items center
    position fixed
    top 50%
    left 50%
    margin -170px 0 0 -160px
    width 320px
    height 340px
    padding 20px
    background-color #fff
    border-radius 20px
    box-shadow 0 0 20px 0 rgba(0 0 0 0.5)
    z-index 5
    &.md
      margin -250px 0 0 -250px
      width 500px
      height 500px
      img
        width 200px
        height 200px
    h3
      color #000
    .premium-icon
      display inline-block
      width 100px
      height 100px
      background-image url('/static_files/icons/premium-quality.svg')
      background-size 100px
    .actions
      button
        background-color #fff
        color #000
        sup
          background-color #fd8087
          color #fff
          padding 2px 10px
          border-radius 20px
      span
        margin-left 10px
        font-size 1.4rem
        color #000
        opacity .75
        cursor pointer
        transition opacity .2s ease
        &:hover
          opacity 1
  table
    margin-bottom 40px
    width 100%
    tr
      td
        padding 10px 20px
        border none
        text-align center
        &.plus
          color rgba(76,175,80, 1)
          font-size 3rem
        &.minus
          color red
          font-size 3rem
  ul
    width: 800px
    margin: 40px auto 40px
    display: grid
    grid-template-columns 300px
    justify-content: center
    list-style: none
    li
      position relative
      height 480px
      color #fff
      border-radius 0 0 20px 20px
      background-size cover
      box-shadow 0 0 20px 1px rgba(0 0 0 .35)
      text-align center
      cursor default
      transition all .2s ease-out
      &:after
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background linear-gradient(0deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 100%)
        border-radius 20px
      &:hover
        box-shadow 0 10px 20px 1px rgba(0 0 0 0.35)
        transform translateY(-10px)
        opacity 1
      &:hover > .footer-premium .btn
        background-color #ee7203
        color #fff
      .header-premium
        position relative
        top 0
        padding 5px 10px 10px
        width 100%
        font-size 3rem
        font-weight bold
        color #fff
        background-color rgba(0 0 0 0.75)
        border-radius 0px 0px 100% 100%
        text-transform uppercase
        span
          display block
          font-weight normal
          font-size 1.4rem
          opacity .9
      div
        width 100%
        text-align center
        z-index 1
        &.body-premium
          position absolute
          top: 60%
          span
            font-size 2.4rem
            text-transform uppercase
          .sitecoin
            display block
            margin-top 20px
            span
              font-size 1.4rem
              text-transform capitalize
            i
              display: inline-block
              width 16px
              height 16px
              background-image: url('/static_files/icons/coin-dark.png')
              background-size 16px
              vertical-align: middle
        &.footer-premium
          position absolute
          bottom 20px
          .btn
            display inline-block
            position relative
            padding 15px 40px
            font-size 1.5rem
            font-weight: 400
            color #fff
            background-color #333
            border none
            border-radius 3px
            cursor pointer
            overflow hidden
            transition all .2s ease
            z-index 1
            &:hover:before
              webkit-transform: skewX(-45deg) translateX(13.5em);
              transform: skewX(-45deg) translateX(22.5em);
              -webkit-transition: all 0.5s ease-in-out;
              transition: all 0.5s ease-in-out;
            &:before
              content: "";
              background-color: rgba(255, 255, 255, 0.5);
              height: 100%;
              width: 3em;
              display: block;
              position: absolute;
              top: 0;
              left: -4.5em;
              -webkit-transform: skewX(-45deg) translateX(0);
              transform: skewX(-45deg) translateX(0);
              -webkit-transition: none;
              transition: none;
    li:nth-child(2)
      opacity 1
      &:after
        background linear-gradient(0deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%)
      .header-premium
        background-color #ee7203
        color #000
</style>
